'use client';

import React, { useState } from 'react';

import { Modal } from '../Modal/Modal';
import { ProductNames } from '../../constants/ProductNames';
import { SHARE_PLATFORM_SEARCH_PARAM } from '../../utils/sharing/common';
import dynamic from 'next/dynamic';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { usePage } from '../Providers/PageProvider';
import { useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';

const SharePage = dynamic(() =>
  import('../SharePage/SharePage').then((x) => x.SharePage),
);

type ShareButtonProps = {
  id: string;
};

export const ShareButton = ({ id }: ShareButtonProps) => {
  const { t } = useTranslation();
  const search = useSearchParams();
  const [open, setOpen] = useState(
    Boolean(search.get(SHARE_PLATFORM_SEARCH_PARAM)),
  );
  const { owner, product } = usePage();
  const isPageOwner = useIsPageOwner();

  function getHeading(): string {
    if (isPageOwner) {
      return t('sharePage.heading.pageOwner');
    }

    if (
      product.name === ProductNames.Team ||
      product.name === ProductNames.ProxyTeam
    ) {
      return t('sharePage.heading.team', { pageOwnerName: owner.name });
    }

    return t('sharePage.heading', { pageOwnerName: owner.name });
  }

  return (
    <>
      <button
        id={id}
        className="cp-btn cp-btn-secondary w-full"
        onClick={() => setOpen(true)}
      >
        {t('share')}
      </button>
      <Modal onClose={() => setOpen(false)} open={open}>
        <Modal.CloseButton />
        <SharePage
          heading={getHeading()}
          subheading={t('sharePage.subHeading')}
        />
      </Modal>
    </>
  );
};
